export var NoteTypes;
(function (NoteTypes) {
    NoteTypes["MESSAGE"] = "MESSAGE";
    NoteTypes["KID"] = "KID";
    NoteTypes["KID_OR_MESSAGE"] = "KID_OR_MESSAGE";
})(NoteTypes || (NoteTypes = {}));
export var InterestType;
(function (InterestType) {
    InterestType[InterestType["CREDIT"] = 0] = "CREDIT";
    InterestType[InterestType["DEBIT"] = 1] = "DEBIT";
})(InterestType || (InterestType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhbnNsYXRpb25UeXBlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3RyYW5zbGF0aW9ucy90cmFuc2xhdGlvblR5cGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBaUdBLE1BQU0sQ0FBTixJQUFZLFNBSVg7QUFKRCxXQUFZLFNBQVM7SUFDakIsZ0NBQW1CLENBQUE7SUFDbkIsd0JBQVcsQ0FBQTtJQUNYLDhDQUFpQyxDQUFBO0FBQ3JDLENBQUMsRUFKVyxTQUFTLEtBQVQsU0FBUyxRQUlwQjtBQTZpREQsTUFBTSxDQUFOLElBQVksWUFHWDtBQUhELFdBQVksWUFBWTtJQUNwQixtREFBTSxDQUFBO0lBQ04saURBQUssQ0FBQTtBQUNULENBQUMsRUFIVyxZQUFZLEtBQVosWUFBWSxRQUd2QiJ9